module.exports = __webpack_public_path__ + "static/media/Gas.2d34dd36.png";